import { render, staticRenderFns } from "./AudienceStatusColumn.vue?vue&type=template&id=54b1ac0c&"
import script from "./AudienceStatusColumn.vue?vue&type=script&lang=ts&"
export * from "./AudienceStatusColumn.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceStatusColumn.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports